import React, { useEffect, useState } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { useFormik } from "formik";
import { useSnackbarGlobal } from "../../globals/SnackbarGlobal/SnackbarGlobal";
import { useIntl } from "react-intl";
import { Container, Button, Grid, Box } from "@material-ui/core";
import { useTitleGlobal } from "../../globals/TitleGlobal/TitleGlobal";
import AgreementCheckbox from "./AgreementCheckbox";
import ContactInformationForm from "./ContactInformationForm";
import DataProcessingAgreementText from "./DataProcessingAgreementText";
import DetailsForm from "./DetailsForm";
import Header from "./Header";
import PreviousExperiencesForm from "./PreviousExperiencesForm";
import ReCAPTCHAForm from "./ReCAPTCHAForm";
import ValidationSchema from "./ValidationSchema";
import { useCommonService } from "../../services/CommonService/CommonService";
import { useCancelToken } from "../../services/AxiosService/AxiosService";
import { IAddFranchiseRequestModel } from "../../services/CommonService/models";
import FormSubmittedDialog from "./FormSubmittedDialog";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      paddingBottom: theme.spacing(3)
    },
    submitButton: {
      backgroundColor: theme.palette.pomagranatered.main,
      float: "right",
      width: "304px"
    },
    recaptcha: {
      float: "right"
    }
  })
);

function RequestFranchiseForm() {
  const classes = useStyles();
  const intl = useIntl();
  const snackbarGlobal = useSnackbarGlobal();
  const commonService = useCommonService();
  const [token, cancelToken] = useCancelToken();
  const titleGlobal = useTitleGlobal();
  const [agreed, setAgreed] = useState(false);
  const [reCAPTCHAToken, setReCAPTCHAToken] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState<boolean>(false);

  const formik = useFormik({
    initialValues: {
      FullName: "",
      BirthDate: "",
      NationalIdNumber: "",
      EducationLevel: "",
      Phone: "+90 (5",
      Email: "",
      ResidenceCity: "",
      ResidenceAddress: "",
      PreviousCompanyAndTitle: "",
      PreviousPosition: "",
      PreviousExperienceStartDate: "",
      PreviousExperienceEndDate: "",
      IsCurrentRole: false,
      FranchiseCity: "",
      FranchiseDistrict: "",
      FranchiseQuarter: "",
      InvestmentAmount: "",
      HasAnotherOccupation: "",
      CurrentMonthlyIncome: "",
      ExpectedMonthlyIncome: "",
      Investor: "",
      Manager: "",
      HasManagedCourierOrWarehousePersonnel: "",
      WhyBanabi: ""
    },
    validationSchema: ValidationSchema,
    validateOnMount: false,
    isInitialValid: false,
    validateOnBlur: true,
    onSubmit: async (values) => {
      const isSuccesfull = await commonService.addFranchiseRequest(token, ({
        ...values,
        ReCAPTCHAToken: reCAPTCHAToken
      } as unknown) as IAddFranchiseRequestModel);

      if (isSuccesfull) {
        setSubmitted(true);
      } else {
        snackbarGlobal.open(intl.formatMessage({ id: "UNEXPECTED_ERROR" }), "error");
      }
    }
  });

  // Title changes.
  useEffect(() => {
    titleGlobal.update(intl.formatMessage({ id: "PAGE_TITLE" }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAgreementCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAgreed(event.target.checked);
  };

  const handleReCAPTCHAchange = (token: string | null) => {
    setReCAPTCHAToken(token);
  };

  const handleSubmitButtonClick = () => {
    if (!formik.isValid) {
      snackbarGlobal.open(intl.formatMessage({ id: "FORM_VALIDATION_ERROR" }), "error");
    }

    formik.submitForm();
  };

  return (
    <React.Fragment>
      <Header />
      <Container className={classes.container} maxWidth="lg">
        <form>
          <ContactInformationForm formik={formik} />
          <PreviousExperiencesForm formik={formik} />
          <DetailsForm formik={formik} />
          <AgreementCheckbox onChange={handleAgreementCheckboxChange} aggreed={agreed} />
          <DataProcessingAgreementText />
          <Grid container spacing={3} justifyContent="center">
            <Grid item sm={12}>
              <Box className={classes.recaptcha}>
                <ReCAPTCHAForm handleChange={handleReCAPTCHAchange} />
              </Box>
            </Grid>
            <Grid item sm={12}>
              <Button
                disabled={!agreed || reCAPTCHAToken === null || submitted || formik.isSubmitting}
                className={classes.submitButton}
                variant="contained"
                color="secondary"
                size="large"
                onClick={handleSubmitButtonClick}
              >
                {intl.formatMessage({ id: "SUBMIT" })}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Container>
      <FormSubmittedDialog open={submitted} />
    </React.Fragment>
  );
}

export default RequestFranchiseForm;
